import { Component, OnInit } from '@angular/core';
import { Service } from 'src/app/assabil-sales/models/entities/service';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { ToastrService } from 'ngx-toastr';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { Location } from '@angular/common';
import { ConfigService } from 'src/app/tools/services/config.service';
import { SettlementService } from 'src/app/assabil-sales/services/settlement-service';
import { BankNote } from 'src/app/assabil-kernel/models/entities/control-tables/bank-note';
import { SalesReportsService } from 'src/app/assabil-sales/services/sales-reports-service';
import { MatDialog } from '@angular/material/dialog';
import { LeanConfirmationComponent } from 'src/app/tools/components/lean-confirmation/lean-confirmation.component';
import { PaymentTermPayment } from 'src/app/assabil-sales/models/dtos/payment-term-payment';
import { Payment } from 'src/app/assabil-sales/models/entities/payment';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { PaymentTerm } from 'src/app/assabil-kernel/models/entities/control-tables/payment-term';
import { PaymentWidgetModal } from '../payment-widget/payment-widget.component';
import { PartnerLovComponent } from 'src/app/assabil-admin/components/master-data/partner/partner-lov/partner-lov.component';
import { RoleLovComponent } from 'src/app/assabil-admin/components/master-data/role/role-lov/role-lov.component';
import { PersonLovComponent } from 'src/app/assabil-admin/components/master-data/person/person-lov/person-lov.component';
import { PaymentTermLovComponent } from 'src/app/assabil-admin/components/control-tables/payment-term-lov/payment-term-lov.component';
import { BankLovComponent } from 'src/app/assabil-admin/components/control-tables/bank-lov/bank-lov.component';
import { UserService } from 'src/app/assabil-kernel/services/user-service';

@Component({
    selector: 'settlement',
    templateUrl: './settlement.component.html',
    styleUrls: ['./settlement.component.scss']
})


export class SettlementComponent implements OnInit {

    services                : Service[];
    bankNotes 	            : BankNote[];
    paymentTermPayments     : PaymentTermPayment[];
    savePaymentTermPayments : PaymentTermPayment[];
    code                    : string;
    startDate               : Date;
    endDate                 : Date;
    salesAmountTotal        : number = 0;

    cashAmount              : number = 0;


    role                : Role = new Role();

    constructor(
        protected settlementService     : SettlementService,
        protected masterDataService     : MasterDataService,
        protected toastr                : ToastrService,
        protected leanUtilsService      : LeanUtilsService, 
        protected dialog                : MatDialog,
        protected location              : Location,
        protected baseService           : BaseService,
        protected userService           : UserService,
        protected configService         : ConfigService,
        protected salesReportsService   : SalesReportsService) {

    }
    ngOnInit(): void {
        this.initPaymentFormFields();
    }

    returnBack(){
        this.location.back();
    }

    loadData(firstLoad : boolean) {
        
        let pleaseFillField = "Priere de renseigner le champ : ";

        if (this.leanUtilsService.isBlank(this.code)) {
            this.leanUtilsService.error(pleaseFillField + "Code");
            return false;
        }

        if (firstLoad) this.initAmounts();

        this.masterDataService.rolesGet(this.code).then(roles => {
            if (roles && (roles.length>0)){
                this.role = roles[0];
                this.settlementService.settlementDataGet(this.code).then(settlementDataResponse => {
                    this.services                   = settlementDataResponse.services;
                    if (firstLoad) this.bankNotes   = settlementDataResponse.bankNotes;
                    this.paymentTermPayments        = settlementDataResponse.paymentTermPayments;
                    this.salesAmountTotal = 0;
                    if (this.services) {
                    this.services.forEach(service =>{
                                this.salesAmountTotal += service.salesAmount;
                    })

                    // in case of reload after adding payments, we should restore amount per paymentTerm entered by user
                    // -----------------------------------------------------------------------------------------------------------------------------
                    if (! firstLoad) {
                        for (let paymentTermPayment of this.paymentTermPayments){
                            for (let savedPaymentTermPayment of this.savePaymentTermPayments){
                                if (paymentTermPayment.paymentTerm.paymentTermCode == savedPaymentTermPayment.paymentTerm.paymentTermCode) {
                                    paymentTermPayment.enteredAmount = savedPaymentTermPayment.enteredAmount;
                                    break;
                                }
                            }
                        }
                    }
                    // -----------------------------------------------------------------------------------------------------------------------------

                    }
                })
            } else{
                this.role               = new Role();
                this.services           = null;
                this.bankNotes          = null;
                this.salesAmountTotal   = 0;
                this.salesAmountTotal   = 0;
            }
        })
    }

    //----------------------------------------------------------------------------------------------------------------------------------
    getBankNotesTotalValue() : number {
        let result = 0;
        for(let bankNote of this.bankNotes) {
            result += bankNote.theNumber * bankNote.theValue;
        }
        return result;
    }
    //----------------------------------------------------------------------------------------------------------------------------------
    

    //----------------------------------------------------------------------------------------------------------------------------------
    lastSettlementCode : string;
    settlementValidate(){

        if (this.bankNotes && this.bankNotes.length > 0 && this.getBankNotesTotalValue() != this.cashAmount){
            this.leanUtilsService.error("Le montant saisi dans 'Encaissement Espèce' ne correspond pas à la valeur totale des coupures de banque");
            return;
        }


        for(let paymentTermPayment of this.paymentTermPayments) {
            let amount : number = 0;
            for(let payment of paymentTermPayment.payments) {
                amount += payment.amount;
            }
            if(!paymentTermPayment.enteredAmount) paymentTermPayment.enteredAmount = 0;
            if (amount != paymentTermPayment.enteredAmount){
                this.leanUtilsService.error("Le montant saisi du '" + paymentTermPayment.paymentTerm.paymentTermCode + "' ne correspond pas à la valeur totale de ses paiements");
                return;
            }
        }

        let totalAmount = this.cashAmount + this.getNonCashAmount();
        let confirmationMessage = "Confimez-vous bien l'encaissment d'un montant de " + totalAmount + " Dh";

        let dialogRef = this.dialog.open(LeanConfirmationComponent, {autoFocus : false, hasBackdrop : false, data : {title : "Confirmation", confirmationMessage: confirmationMessage}});
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.settlementValidate2();
            }
        });
    }

    getNonCashAmount() : number {
        let amount = 0;
        for (let paymentTermPayment of this.paymentTermPayments){
            if (paymentTermPayment.enteredAmount) amount += paymentTermPayment.enteredAmount;
        }
        return amount;
    }

    settlementValidate2(){
        this.settlementService.settlementValidate(this.code, this.services, this.bankNotes, this.cashAmount, this.getNonCashAmount()).then(settlementCode => {
            this.leanUtilsService.success();
            this.lastSettlementCode = settlementCode;
        })
    }
   //----------------------------------------------------------------------------------------------------------------------------------
 

    settlementPrint(){
        this.settlementService.settlementPrint(this.lastSettlementCode ).then(pdf => {
            this.leanUtilsService.printPdf(pdf);
        })
    }
    initAmounts(){
        this.cashAmount = 0;
    }

    //---------------------------------------------------------------------------------------
    print(){
        this.salesReportsService.settelmentPrint();
    }
    //---------------------------------------------------------------------------------------

   //---------------------------------------------------------------------------------------
   addPayments(service : Service){
        let payment : Payment = new Payment();
        payment.person       = this.userService.userInfo.person
        payment.role         = this.userService.userInfo.person.role;
        payment.paymentTerm  = new PaymentTerm();
        payment.service      = service;
        payment.theDate      = new Date();
        payment.edit         = true; 
        payment.inserted     = true; 

        let dialogRef = this.dialog.open(PaymentWidgetModal, {autoFocus : false, hasBackdrop : false, data : {payment : payment, columns : this.paymentFormFields}});
        dialogRef.afterClosed().subscribe(result => {
        if(result){
            this.savePaymentTermPayments = this.paymentTermPayments;
            this.loadData(false);
        }
        });
    }
   //---------------------------------------------------------------------------------------

   //---------------------------------------------------------------------------------------
   showPayment(payment : Payment){
    let dialogRef = this.dialog.open(PaymentWidgetModal, {autoFocus : false, hasBackdrop : false, data : {payment : payment, columns : this.paymentFormFields}});
    dialogRef.afterClosed().subscribe(result => {
    if(result){
        this.savePaymentTermPayments = this.paymentTermPayments;
        this.loadData(false);
    }
    });
   }
   //---------------------------------------------------------------------------------------
   
   //---------------------------------------------------------------------------------------
    paymentFormFields : any[];
    initPaymentFormFields(){
        this.baseService.fieldsGet("payment").then(result => {
            this.paymentFormFields = result.formFields;
            this.processFields();
        })
    }
    processFields(){
        for (let field of this.paymentFormFields){
            if (field.prop == 'partner')    { field.modal = PartnerLovComponent;    field.subProp = 'name';}
            if (field.prop == 'role')       { field.modal = RoleLovComponent;       field.subProp = 'name';}
            if (field.prop == 'person')     { field.modal = PersonLovComponent;     field.subProp = 'name';}
            if (field.prop == 'paymentTerm'){ field.modal = PaymentTermLovComponent;field.subProp = 'name';}
            if (field.prop == 'bank')       { field.modal = BankLovComponent;       field.subProp = 'name';}
        }
    }
    //---------------------------------------------------------------------------------------

}
